module.exports = __webpack_public_path__ + "static/media/3_col_5.c752b265.jpg";